import classnames from "classnames";
import React from "react";

import { DeliveryTypes } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type DeliveryTypesComponentProps = {
    allowClickAndCollect: boolean;
    allowHomeDelivery: boolean;
};

const DeliveryTypesComponent = ({
    allowClickAndCollect,
    allowHomeDelivery,
}: DeliveryTypesComponentProps) => {
    const { t } = useGranite();

    return (
        <div className="productTile__deliveryType">
            {allowClickAndCollect && (
                <div
                    className={classnames("productTile__deliveryType-item", {
                        "pr-2": allowHomeDelivery,
                    })}
                >
                    <span className="productTile__deliveryType-item_icon"></span>
                    <span className="productTile__deliveryType-item_text">
                        {t(
                            `productTile.delivery.type.${DeliveryTypes.ClickAndCollect}`,
                        )}
                    </span>
                </div>
            )}
            {allowHomeDelivery && (
                <div className="productTile__deliveryType-item">
                    <span className="productTile__deliveryType-item_icon"></span>
                    <span className="productTile__deliveryType-item_text">
                        {t(
                            `productTile.delivery.type.${DeliveryTypes.HomeDelivery}`,
                        )}
                    </span>
                </div>
            )}
        </div>
    );
};

export default DeliveryTypesComponent;
